webpackJsonp([18],{

/***/ 1005:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__(113);
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/inputs/index.js + 75 modules
var inputs = __webpack_require__(170);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Links.vue






/* harmony default export */ var Links = ({
  components: {
    TextInput: inputs["t" /* TextInput */],
    FileInput: inputs["i" /* FileInput */]
  },
  data: function data() {
    var platform = this.$store.getters['skiliko/session/currentPlatform'];
    return {
      snackbar: false,
      links: platform.settings.smartlinks || [],
      url: platform.url + '/smartlink'
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform',
    loading: 'skiliko/session/isLoading'
  }), {
    settings: function settings() {
      return extends_default()({}, this.platform.settings, {
        smartlinks: this.links
      });
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    savePlatform: 'skiliko/session/updateCurrentPlatform'
  }), {
    add: function add() {
      this.links.push({
        title: '',
        url: '',
        icon: ''
      });
    },
    up: function up(i) {
      var a = this.links[i];
      var b = this.links[i - 1];
      this.links.splice(i - 1, 2, a, b);
    },
    down: function down(i) {
      var a = this.links[i];
      var b = this.links[i + 1];
      this.links.splice(i, 2, b, a);
    },
    remove: function remove(i) {
      this.links.splice(i, 1);
    },
    saveSettings: function saveSettings() {
      this.savePlatform({
        data: {
          settings: stringify_default()(this.settings)
        }
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eebb03c2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Links.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_vm._v("\n      Smart Links\n      "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.url),expression:"url",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(function () { return _vm.snackbar = true; }),expression:"() => snackbar = true",arg:"success"}],attrs:{"icon":""}},[_c('v-icon',[_vm._v("link")])],1),_vm._v(" "),_c('a',{staticClass:"caption",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.url))])],1),_vm._v(" "),_c('v-snackbar',{model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      "+_vm._s(_vm.$t('service.actions.copy'))+"\n      "),_c('v-btn',{attrs:{"icon":"","light":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_vm._l((_vm.links),function(link,i){return _c('v-card',{key:i,staticClass:"mb-2"},[_c('v-card-text',[(link.icon)?_c('img',{staticClass:"link-img",attrs:{"src":link.icon}}):_vm._e(),_vm._v(" "),_c('file-input',{attrs:{"config":{ label: _vm.$t('smartlink.icon'), path: 'smartlink' }},model:{value:(link.icon),callback:function ($$v) {_vm.$set(link, "icon", $$v)},expression:"link.icon"}}),_vm._v(" "),_c('text-input',{attrs:{"config":{ label: _vm.$t('smartlink.title'), required: true }},model:{value:(link.title),callback:function ($$v) {_vm.$set(link, "title", $$v)},expression:"link.title"}}),_vm._v(" "),_c('text-input',{attrs:{"config":{ type: 'url', label: _vm.$t('smartlink.url'), required: true }},model:{value:(link.url),callback:function ($$v) {_vm.$set(link, "url", $$v)},expression:"link.url"}})],1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.remove(i)}}},[_vm._v("\n            "+_vm._s(_vm.$t('service.form.delete'))+"\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","disabled":i === 0},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.up(i)}}},[_c('v-icon',[_vm._v("keyboard_arrow_up")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","disabled":i === _vm.links.length - 1},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.down(i)}}},[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)],1)],1)}),_vm._v(" "),_c('v-btn',{attrs:{"primary":"","light":"","outline":"","type":"submit"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.add.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('smartlink.add')))])],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"type":"submit","loading":_vm.loading,"primary":"","light":"","ripple":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.saveSettings.apply(null, arguments)}}},[_vm._v("\n        "+_vm._s(_vm.$t('smartlink.save'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_Links = (esExports);
// CONCATENATED MODULE: ./src/pages/Links.vue
function injectStyle (ssrContext) {
  __webpack_require__(976)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eebb03c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Links,
  pages_Links,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_Links = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(977);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("70c315c1", content, true);

/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".link-img[data-v-eebb03c2]{border-radius:100%;height:48px;width:48px}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/Links.vue"],"names":[],"mappings":"AACA,2BACE,mBAAoB,AACpB,YAAa,AACb,UAAY,CACb","file":"Links.vue","sourcesContent":["\n.link-img[data-v-eebb03c2] {\n  border-radius: 100%;\n  height: 48px;\n  width: 48px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/18.64a600a3fa415f459806.js